export default __webpack_public_path__ + "static/similarity-do-037b33fcd4230c95cd191a9dd81ae5587da5bf19ef760df65ad974d7f63dee75.png";